import React from 'react';
import { SignupData } from '../../pages/SignupPage';
import { CheckCircleIcon } from 'lucide-react';
interface SportSelectionProps {
  onNext: () => void;
  onBack: () => void;
  updateData: (data: Partial<SignupData>) => void;
  selectedSport: string;
}
const SportSelection: React.FC<SportSelectionProps> = ({
  onNext,
  onBack,
  updateData,
  selectedSport
}) => {
  const sports = [{
    id: 'football',
    name: 'Football',
    icon: '⚽'
  }, {
    id: 'basketball',
    name: 'Basketball',
    icon: '🏀'
  }, {
    id: 'baseball',
    name: 'Baseball',
    icon: '⚾'
  }, {
    id: 'tennis',
    name: 'Tennis',
    icon: '🎾'
  }, {
    id: 'golf',
    name: 'Golf',
    icon: '⛳'
  }, {
    id: 'volleyball',
    name: 'Volleyball',
    icon: '🏐'
  }, {
    id: 'rugby',
    name: 'Rugby',
    icon: '🏉'
  }, {
    id: 'hockey',
    name: 'Hockey',
    icon: '🏒'
  }, {
    id: 'cricket',
    name: 'Cricket',
    icon: '🏏'
  }, {
    id: 'swimming',
    name: 'Swimming',
    icon: '🏊‍♂️'
  }, {
    id: 'athletics',
    name: 'Athletics',
    icon: '🏃‍♂️'
  }, {
    id: 'cycling',
    name: 'Cycling',
    icon: '🚴‍♀️'
  }];
  const handleSelectSport = (sportId: string) => {
    updateData({
      sport: sportId
    });
  };
  const handleContinue = () => {
    if (selectedSport) {
      onNext();
    }
  };
  return <div className="p-4" data-id="element-324">
      <p className="text-gray-600 text-center mb-6" data-id="element-325">
        Select your primary sport. You can add more sports later.
      </p>
      <div className="grid grid-cols-3 gap-3" data-id="element-326">
        {sports.map(sport => <button key={sport.id} className={`
              relative aspect-square flex flex-col items-center justify-center p-3 rounded-xl border-2
              ${selectedSport === sport.id ? 'border-blue-500 bg-blue-50' : 'border-gray-200 bg-white'}
            `} onClick={() => handleSelectSport(sport.id)} data-id="element-327">
            {selectedSport === sport.id && <div className="absolute top-1 right-1 text-blue-500" data-id="element-328">
                <CheckCircleIcon size={16} fill="currentColor" data-id="element-329" />
              </div>}
            <span className="text-2xl mb-1" data-id="element-330">{sport.icon}</span>
            <span className="text-sm font-medium" data-id="element-331">{sport.name}</span>
          </button>)}
      </div>
      <div className="mt-6" data-id="element-332">
        <button onClick={handleContinue} disabled={!selectedSport} className={`
            w-full py-3 rounded-lg font-medium text-white
            ${selectedSport ? 'bg-blue-600 hover:bg-blue-700' : 'bg-gray-300 cursor-not-allowed'}
          `} data-id="element-333">
          Continue
        </button>
      </div>
    </div>;
};
export default SportSelection;